/**
 * PM Orchestrator — initializes the private messages interface.
 *
 * All logic has been extracted into modules under pm/*.js.
 * This file handles document.ready initialization and event wiring only.
 *
 * Module load order (via webpack entry):
 *   pm/state.js            — global state variables
 *   pm/drafts.js           — localStorage draft persistence
 *   pm/typing.js           — WebSocket typing/newmessage handlers
 *   pm/scroll.js           — scroll management
 *   pm/layout.js           — responsive layout, draggable separator, placeholder panel
 *   pm/polling.js          — periodic AJAX update polling, read receipts
 *   pm/crud.js             — contact management, message/thread operations, search
 *   pm/thread-view.js      — open/close threads, header updates
 *   pm/message-actions.js  — message action menus, reply, swipe-to-reply
 *   pm/pagination.js       — paginated view mode
 *   pm/calendar-jump.js    — date-based message navigation
 *   pm/legacy.js           — classic mbox/mcompose/drafts pages
 */

// Onload
$(document).ready(function() {
  if ($(".privateMessages").length === 0) {
    return;
  }
  window.pm_ajax_request_active = 0;
  window.messages_highlighted = 1;

  // Initialize scroll for direct navigation (thread open on page load)
  var threadsRight = $("#threads_right");
  var threadsMain = $("#threads_main");
  if (threadsRight.length > 0 && threadsMain.hasClass("threads--open")) {
    window.setupScrollObserver(threadsRight);
    // If user prefers paginated view, switch to it instead of scrolling to bottom
    if (localStorage.getItem('pm_paged_view') === '1') {
      setTimeout(function() { window.activatePagedView(); }, 200);
    } else {
      setTimeout(function() {
        window.scrollToBottomAfterImagesLoad(threadsRight, 3000);
      }, 100);
    }
    // Consolidate read receipts after initial render
    setTimeout(function() {
      if (window.consolidateReadReceipts) window.consolidateReadReceipts();
    }, 200);
  }

  // Handle orientation changes on mobile
  var resizeTimeout;
  $(window).on('resize orientationchange', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      var tr = $("#threads_right");
      if (tr.length > 0 && tr.find('.msg').length > 0) {
        window.scrollToBottomEnhanced(tr, 100, false);
      }
    }, 250);
  });

  // Stop tab title flashing when user focuses the window
  $(window).on('focus', function() {
    if (typeof window.stopFlashTitle === 'function') {
      window.stopFlashTitle();
    }
  });
  window.last_ads_reload = new Date().getTime();
  // Avoid multiple calls of load more threads called by scroll
  window.load_more_threads_active = 0;
  // Avoid multiple calls of load_more_msg
  window.load_more_msg_active = 0;
  // Array of drafts
  window.last_draft = {};
  // Initialize dragging state
  window.isDragging = false;

  // Only autofocus on desktop to avoid opening virtual keyboard on mobile
  if (window.matchMedia('(min-width: 640px)').matches) {
    $("#message").focus();
  }

  // Restore local draft, overriding stale server-rendered draft
  var initialThreadId = $("#send_thread_id").val();
  if (initialThreadId) {
    var localDraft = window.draftStorage.load(initialThreadId);
    var serverDraft = $("#message").val()?.trim() || '';
    if (localDraft !== null && localDraft !== serverDraft) {
      $("#message").val(localDraft);
      if (localDraft) {
        $("#threads_main").addClass("send");
      } else {
        $("#threads_main").removeClass("send");
      }
    }
  }

  // Detect view mode
  window.pm_view_mode = $("#threads_main").hasClass("paged") || $("#single_thread_wrapper").length ? "paged" : "chat";

  if (window.pm_view_mode === "paged") {
    // Load thread on click
    $(document).on("click", ".pm_thread", function(e) {
      // Do not run when clicked on buttons
      if ($(e.target).hasClass("fa")) return false;
      if ($(e.target).hasClass("thumb")) return true;

      // Get thread ID
      var id = $(this).attr("id").replace("thread_", "");

      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname +
        "?thread_id=" + id;
      return false;
    });

    // Remove highlighting from new messages in 3s
    window.setTimeout(function() {
      window.remove_new_mark();
    }, 3000);

    // If user push back btn in classic view after using split view
    if (window.htm5_history_supported) {
      // Listen to htm5 history events
      window.addEventListener("popstate", function(e) {
        if (e.state) {
          // Redirect to url in path (simulate browser history)
          let loc = window.location.protocol + "//" +
            window.location.hostname + window.location.pathname;
          if (typeof e.state.thread_id != "undefined" && !isNaN(e.state.thread_id) &&
            (e.state.thread_id != "")) {
            loc += "?thread_id=" + e.state.thread_id;
          }
          window.location.href = loc;
        }
        return false;
      }, false);
    }
  }

  // Run filter by username on enter
  $(document).on("keyup", "#username_filter", function(e) {
    if (e.keyCode === 13) {
      window.find_contact();
    }
  });

  // Run add contact on enter
  $(document).on("keyup", "#new_contact", function(e) {
    if (e.keyCode === 13) {
      window.add_contact();
    }
  });

  // Regular updates
  window.run_update_process();

  // Chat view mode related functions
  if (window.pm_view_mode === "chat") {
    // Load more messages on scroll up or "Load more" link click
    // With column-reverse, scrollTop=0 is bottom; scrolling UP makes scrollTop negative
    $("#threads_right").scroll(function() {
      // Show/hide jump-to-latest button based on scroll position
      var jumpBtn = document.getElementById('jump-to-latest-btn');
      var inDateJump = window.calendarJump && window.calendarJump.dateJumpActive;
      if (jumpBtn && !window.pagedViewActive) {
        if (inDateJump || Math.abs(this.scrollTop) > 300) {
          var compose = document.getElementById('threads_right_bottom');
          jumpBtn.style.bottom = (compose ? compose.offsetHeight + 12 : 80) + 'px';
          jumpBtn.classList.remove('hidden');
          jumpBtn.classList.add('flex');
        } else {
          jumpBtn.classList.add('hidden');
          jumpBtn.classList.remove('flex');
        }
      }

      // In date-jump mode: load older messages when scrolling to top
      if (inDateJump) {
        if (this.scrollTop <= 5 && !window.pm_ajax_request_active) {
          window.calendarJump._loadOlderMessages();
        }
        return;
      }

      // Avoid multiple calls; skip in paginated view mode
      if (window.load_more_msg_active == 1 || window.pagedViewActive) return;
      var el = this;
      if (Math.abs(el.scrollTop) >= el.scrollHeight - el.clientHeight - 5) window.load_more_msg();
    });
    $(document).on("click", "#load_older_messages", window.load_more_msg);

    // Remove "new" in 3 seconds
    window.setTimeout(function() {
      window.remove_new_mark();
    }, 3000);

    // Load thread on click
    $(document).on("click", ".pm_thread", function(e) {
      // Do not run when clicked on buttons, icons, or thumbnails
      if ($(e.target).hasClass("fa")) return false;
      if ($(e.target).hasClass("thumb")) return true;
      if ($(e.target).is("button")) return false;
      if ($(e.target).closest("button").length) return false;
      if ($(e.target).closest(".thread-swipe-actions").length) return false;
      if ($(e.target).closest(".thread-desktop-actions").length) return false;
      if ($(e.target).closest(".thread-avatar").length) return true;

      // Don't open thread if user was swiping
      if (window.isDragging) return false;

      e.preventDefault();

      // Get thread ID
      let id = $(this).attr("id").replace("thread_", "");

      // If html5 history not supported use redirect
      if (!window.htm5_history_supported) {
        window.location.href = window.location.protocol + "//" +
          window.location.hostname + window.location.pathname +
          "?thread_id=" + id;
        return false;
      }

      // Push url to html5 history
      let stateObj = { "thread_id": id };
      history.pushState(stateObj, null, "/app/messages?thread_id=" + id);

      window.view_thread(id, true);
    });

    if (window.htm5_history_supported) {
      // Listen to htm5 history events
      window.addEventListener("popstate", function(e) {
        // Jump to thread in path (simulate browser history)
        if (e.state) {
          if (typeof e.state.thread_id != "undefined" && !isNaN(e.state.thread_id) &&
            (e.state.thread_id != "")) {
            window.view_thread(e.state.thread_id, true);
            return false;
          }
        }
        window.close_thread(true);

        return false;
      }, false);
    }

    // Persist scroll position on thread list scroll
    $("#threads_left").scroll(function() {
      try { sessionStorage.setItem('pm_threads_scroll', this.scrollTop); } catch(e) {}
    });

    // Auto-load older conversations when scrolled near the bottom of the thread list.
    window._threadsFullyLoaded = !document.getElementById('load_more_conversations');
    var threadsLeftEl = document.getElementById('threads_left');
    if (threadsLeftEl) {
      threadsLeftEl.addEventListener('scroll', function() {
        if (window._threadsFullyLoaded || window.load_more_threads_active) return;
        var el = this;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 300) {
          window.load_older_conversations(false);
        }
      });
    }

    // Resize to fit screen
    // window.threads_main_resize();

    if (!window.is_mobile_browser()) {
      // Detect resize end and run resize func
      let rtime = new Date(1, 1, 2000, 12, 0, 0);
      let timeout = false;
      let delta = 500;
      $(window).resize(function() {
        rtime = new Date();
        if (timeout === false) {
          timeout = true;
          setTimeout(window.resizeend, delta);
        }
      });

      window.resizeend = function() {
        if (new Date() - rtime < delta) {
          setTimeout(window.resizeend, delta);
        } else {
          timeout = false;
          // window.threads_main_resize();
        }
      };
    }

    // If opening active thread by direct link
    let activeThread = $("#threads_left .pm_thread.active");
    if (activeThread.length) {
      // Restore saved scroll position, or scroll active thread into view
      var savedScroll = null;
      try { savedScroll = sessionStorage.getItem('pm_threads_scroll'); } catch(e) {}
      var restoreTarget = savedScroll !== null ? parseInt(savedScroll, 10) : null;
      var tlEl = document.getElementById('threads_left');
      if (restoreTarget !== null) {
        tlEl.scrollTop = restoreTarget;
        setTimeout(function() { tlEl.scrollTop = restoreTarget; }, 0);
        setTimeout(function() { tlEl.scrollTop = restoreTarget; }, 50);
        setTimeout(function() { tlEl.scrollTop = restoreTarget; }, 200);
      } else {
        window.scroll_thread_to_middle(activeThread);
      }
      window.open_active_thread_by_link(activeThread);
    }

  } // Chat view related functions END

  // Resize message input textarea to fit content
  const MAX_TEXTAREA_HEIGHT = 128;

  function autoResizeTextarea() {
    const el = this;

    // Reset height to 0 so scrollHeight reflects actual content size
    el.style.height = '0';
    var baseHeight = el.scrollHeight;

    if (baseHeight > MAX_TEXTAREA_HEIGHT) {
      el.style.height = MAX_TEXTAREA_HEIGHT + 'px';
      el.style.overflowY = 'auto';
    } else {
      el.style.height = baseHeight + 'px';
      el.style.overflowY = 'hidden';
    }

    // Keep messages scrolled to bottom when textarea resizes
    // With column-reverse, scrollTop=0 is bottom
    var threadsRight = document.getElementById('threads_right');
    if (threadsRight && Math.abs(threadsRight.scrollTop) < 80) {
      threadsRight.scrollTop = 0;
    }
  }

  $("#message").on("input", autoResizeTextarea);

  // Resize textarea on load if it already has content (e.g. server-rendered draft)
  var msgEl = document.getElementById('message');
  if (msgEl && msgEl.value.length > 0) {
    autoResizeTextarea.call(msgEl);
  }

  // Fade "Enter to send" hint based on input content (visibility gated by CSS: hidden sm:block)
  var sendHint = document.getElementById('send_hint');
  if (sendHint) {
    sendHint.style.opacity = '1';
    $("#message").on("input", function() {
      sendHint.style.opacity = this.value.trim() ? '0' : '1';
    });
  }

  // Send message when pressing enter on desktop; on mobile, Enter inserts newline
  $("#message").on("keydown", function(e) {
    if (e.key === "Enter" && !e.shiftKey && window.matchMedia('(min-width: 640px)').matches) {
      e.preventDefault();
      $("#msg_submit").click();
    }
  });

  // Mobile keyboard handling: hide bottom nav and resize PM container to visual viewport
  if (window.matchMedia('(max-width: 639px)').matches) {
    var pmContainer = document.querySelector('.privateMessages');
    var keyboardTimer = null;
    var isKeyboardOpen = false;

    function updatePmContainerHeight() {
      if (!isKeyboardOpen || !pmContainer) return;
      var vv = window.visualViewport;
      if (vv) {
        pmContainer.style.setProperty('height', vv.height + 'px', 'important');
        pmContainer.style.setProperty('top', vv.offsetTop + 'px', 'important');
        scrollMessagesToBottom();
      }
    }

    function scrollMessagesToBottom() {
      // With column-reverse, scrollTop=0 is bottom
      var threadsRight = document.getElementById('threads_right');
      if (threadsRight) {
        threadsRight.scrollTop = 0;
      }
    }

    function openKeyboard() {
      isKeyboardOpen = true;
      pmContainer.classList.add('keyboard-open');
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updatePmContainerHeight);
        window.visualViewport.addEventListener('scroll', updatePmContainerHeight);
      }
      // Defer layout changes so they don't interfere with iOS focus/caret rendering
      requestAnimationFrame(function() {
        updatePmContainerHeight();
        scrollMessagesToBottom();
        setTimeout(scrollMessagesToBottom, 300);
      });
    }

    function closeKeyboard() {
      isKeyboardOpen = false;
      pmContainer.classList.remove('keyboard-open');
      pmContainer.style.removeProperty('height');
      pmContainer.style.removeProperty('top');
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updatePmContainerHeight);
        window.visualViewport.removeEventListener('scroll', updatePmContainerHeight);
      }
      // Re-run resize after iOS keyboard dismiss animation finishes so
      // visualViewport.height reflects the full viewport, not the
      // stale keyboard-reduced value.
      setTimeout(function() { window.threads_main_resize(); }, 400);
    }

    if (pmContainer) {
      document.addEventListener('focusin', function(e) {
        if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') {
          clearTimeout(keyboardTimer);
          openKeyboard();
        }
      });

      document.addEventListener('focusout', function(e) {
        if (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT') {
          keyboardTimer = setTimeout(function() {
            closeKeyboard();
          }, 100);
        }
      });
    }
  }

  // Update send button state based on message content and photo
  function updateSendButtonState() {
    const $submitBtn = $("#msg_submit");
    const messageText = $("#message").val()?.trim() || '';
    const hasPhotoSelected = window.photoUpload && window.photoUpload.hasPhoto();
    const hasAudioReady = window.audioRecord && window.audioRecord.hasAudio();
    const hasContent = messageText.length > 0 || hasPhotoSelected || hasAudioReady;

    $submitBtn.prop("disabled", !hasContent);

    // Also toggle classes for visual state
    if (hasContent) {
      $submitBtn.removeClass("bg-gray-200 text-gray-400").addClass("bg-sky-500 text-white");
    } else {
      $submitBtn.removeClass("bg-sky-500 text-white").addClass("bg-gray-200 text-gray-400");
    }

    // Hide mic button when typing (can't send text + audio in same message)
    const $micBtn = $("#mic_btn");
    if ($micBtn.length) {
      $micBtn.toggleClass('hidden', messageText.length > 0);
    }
  }

  // Update button state on input changes and persist draft locally
  $("#message").on("input", function () {
    updateSendButtonState();
    const threadId = $("#send_thread_id").val();
    window.draftStorage.save(threadId, $(this).val().trim());
  });

  // Expose function globally for photo upload module to call after selecting/removing photos
  window.updateSendButtonState = updateSendButtonState;

  // Initial state check
  updateSendButtonState();

  // Device detection - determine if we should use swipe or dropdown interface
  const isTouchDevice = () => {
    return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
  };

  const isMobileDevice = () => {
    // Check if the is_mobile_browser function exists and use it for consistency
    if (typeof window.is_mobile_browser === 'function') {
      return window.is_mobile_browser();
    }
    // Fallback to user agent detection
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (
      /android/i.test(userAgent) ||
      /iPad|iPhone|iPod/.test(userAgent) ||
      /windows phone/i.test(userAgent) ||
      /mobile/i.test(userAgent)
    );
  };

  // Determine interface type: use swipe for mobile devices or touch devices with small screens
  const shouldUseSwipeInterface = () => {
    return isMobileDevice() || (isTouchDevice() && window.innerWidth < 768);
  };

  // Initialize interface based on device type
  const initializeThreadActions = () => {
    if (shouldUseSwipeInterface()) {
      // Show swipe interface, hide dropdown interface
      $('.thread-desktop-actions').addClass('hidden');
      $('.thread-swipe-actions').removeClass('hidden');
      $('.thread-swipe-actions').each(function() {
        window.LucideIcons && window.LucideIcons.initialize(this);
      });
    } else {
      // Show dropdown interface, hide swipe interface
      $('.thread-desktop-actions').removeClass('hidden');
      $('.thread-swipe-actions').addClass('hidden');
    }
  };

  // Initialize on load
  initializeThreadActions();
  window.initializeThreadActions = initializeThreadActions;

  // Debounced resize handler to avoid performance issues
  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initializeThreadActions, 150);
  });

  // Toggle the compact filter dropdown
  $("#filters-compact-toggle").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    $("#pm-options-menu").addClass("hidden");
    $("#conversation-actions-menu").addClass("hidden");
    var menu = $("#filters-compact-menu");
    menu.toggleClass("hidden");
    if (!menu.hasClass("hidden")) {
      window.LucideIcons && window.LucideIcons.initialize(menu[0]);
    }
  });

  // Toggle the options menu
  $("#pm-options-toggle").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    // Close other menus first
    $("#filters-compact-menu").addClass("hidden");
    $("#conversation-actions-menu").addClass("hidden");
    $("#pm-options-menu").toggleClass("hidden");
  });

  // Toggle the conversation actions menu
  $("#conversation-actions-toggle").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    // Close other menus first
    $("#filters-compact-menu").addClass("hidden");
    $("#pm-options-menu").addClass("hidden");
    $("#conversation-actions-menu").toggleClass("hidden");
  });

  // Close menus when clicking outside
  $(document).on("click", function(e) {
    if (!$(e.target).closest("#filters-compact-toggle, #filters-compact-menu").length) {
      $("#filters-compact-menu").addClass("hidden");
    }
    if (!$(e.target).closest("#pm-options-toggle, #pm-options-menu").length) {
      $("#pm-options-menu").addClass("hidden");
    }
    if (!$(e.target).closest("#conversation-actions-toggle, #conversation-actions-menu").length) {
      $("#conversation-actions-menu").addClass("hidden");
    }
  });

  // Prevent clicks inside dropdown menus from propagating to thread handlers
  $("#pm-options-menu, #conversation-actions-menu").on('click', function(e) {
    e.stopPropagation();
    if ($(e.target).is('a') || $(e.target).closest('a').length) {
      $(this).addClass("hidden");
    }
  });

  // Handle thread-level action buttons (desktop only)
  $(document).on("click", ".thread-action-btn", function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const $button = $(this);
    const threadId = $button.data("thread-id");
    const isBlockAction = $button.hasClass("thread-action-block");

    if (threadId) {
      window.delete_thread(this, threadId, isBlockAction ? 1 : 0);
    }

    return false;
  });

  // Floating tooltip for thread action buttons — escapes the row's overflow:hidden clipping
  let $threadTooltip = null;
  const getThreadTooltip = () => {
    if (!$threadTooltip) {
      $threadTooltip = $('<span class="px-2 py-1 text-xs text-white bg-gray-900/80 rounded-lg whitespace-nowrap pointer-events-none transition-opacity" style="position:fixed;top:0;left:0;opacity:0;z-index:100;"></span>')
        .appendTo(document.body);
    }
    return $threadTooltip;
  };
  const showThreadTooltip = (btn) => {
    const text = btn.getAttribute('data-tooltip');
    if (!text) return;
    const $tip = getThreadTooltip().text(text);
    const tipEl = $tip[0];
    // Force measurement with visible layout (opacity 0 still measures)
    const btnRect = btn.getBoundingClientRect();
    const tipRect = tipEl.getBoundingClientRect();
    const left = btnRect.left + (btnRect.width / 2) - (tipRect.width / 2);
    const top = btnRect.top - tipRect.height - 6;
    tipEl.style.left = Math.max(4, left) + 'px';
    tipEl.style.top = top + 'px';
    tipEl.style.opacity = '1';
  };
  const hideThreadTooltip = () => {
    if ($threadTooltip) $threadTooltip[0].style.opacity = '0';
  };
  $(document).on('mouseover focusin', '.thread-action-btn[data-tooltip]', function() {
    showThreadTooltip(this);
  });
  $(document).on('mouseout focusout', '.thread-action-btn[data-tooltip]', function() {
    hideThreadTooltip();
  });

  // Mobile swipe functionality
  let touchStartX = 0;
  let touchStartY = 0;
  let currentSwipeThread = null;

  // Touch start handler
  $(document).on('touchstart', '.pm_thread, .message-request-row', function(e) {
    if (!shouldUseSwipeInterface()) return; // Only for swipe interface

    const touch = e.originalEvent.touches[0];
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    window.isDragging = false;
    currentSwipeThread = $(this);

    // Reset any other swiped threads
    $('.thread-swipe-actions').removeClass('translate-x-0').addClass('translate-x-full');
  });

  // Touch move handler
  $(document).on('touchmove', '.pm_thread, .message-request-row', function(e) {
    if (!shouldUseSwipeInterface() || !currentSwipeThread || !currentSwipeThread.is($(this))) return;

    const touch = e.originalEvent.touches[0];
    const deltaX = touchStartX - touch.clientX;
    const deltaY = Math.abs(touchStartY - touch.clientY);

    // Only consider horizontal swipes
    if (deltaY > 30) return;

    if (Math.abs(deltaX) > 10) {
      window.isDragging = true;
      e.preventDefault();

      const $actions = $(this).find('.thread-swipe-actions');

      if (deltaX > 30) {
        // Swiping left - show actions
        $actions.removeClass('translate-x-full').addClass('translate-x-0');
      } else if (deltaX < -10) {
        // Swiping right - hide actions
        $actions.removeClass('translate-x-0').addClass('translate-x-full');
      }
    }
  });

  // Touch end handler
  $(document).on('touchend', '.pm_thread, .message-request-row', function(e) {
    if (!shouldUseSwipeInterface()) return;

    setTimeout(() => {
      window.isDragging = false;
      currentSwipeThread = null;
    }, 100);
  });

  // Close swipe actions when touching elsewhere
  $(document).on('touchstart', function(e) {
    if (!shouldUseSwipeInterface()) return;

    // Don't close if touching within a thread OR within swipe action buttons
    if (!$(e.target).closest('.pm_thread, .message-request-row').length && !$(e.target).closest('.thread-swipe-actions').length) {
      $('.thread-swipe-actions').removeClass('translate-x-0').addClass('translate-x-full');
    }
  });

  // Handle swipe action button interactions
  let swipeActionHandled = false;

  // Handle touch events for swipe action buttons (mobile primary)
  $(document).on('touchstart', '.thread-swipe-actions button', function(e) {
    swipeActionHandled = false;
  });

  $(document).on('touchend', '.thread-swipe-actions button', function(e) {
    if (swipeActionHandled) return false;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    swipeActionHandled = true;

    const $button = $(this);
    const $thread = $button.closest('.pm_thread, .message-request-row');
    const threadId = $thread.data('thread-id');
    const isBlockAction = $button.find('[data-lucide="ban"]').length > 0;

    if (threadId) {
      window.delete_thread(this, threadId, isBlockAction ? 1 : 0);
    }

    return false;
  });

  // Handle click events for swipe action buttons (desktop fallback)
  $(document).on('click', '.thread-swipe-actions button', function(e) {
    if (swipeActionHandled) {
      swipeActionHandled = false;
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const $button = $(this);
    const $thread = $button.closest('.pm_thread, .message-request-row');
    const threadId = $thread.data('thread-id');
    const isBlockAction = $button.find('[data-lucide="ban"]').length > 0;

    if (threadId) {
      window.delete_thread(this, threadId, isBlockAction ? 1 : 0);
    }

    return false;
  });

  // Initialize draggable separator
  window.initDraggableSeparator();

  // Call resize on initial load and after a short delay to ensure all elements are properly loaded
  window.threads_main_resize();
  window.applyPlaceholderPreference();
  setTimeout(function() {
    window.threads_main_resize();
    window.applyPlaceholderPreference();
  }, 200);

  // Add a debounced resize handler to maintain correct sizing
  $(window).on('resize', function() {
    clearTimeout(window.resizeTimer);
    window.resizeTimer = setTimeout(function() {
      window.threads_main_resize();
      window.applyPlaceholderPreference();
    }, 250);
  });

  // Initialize photo upload and message sender modules
  // These are now loaded from separate files for better organization
});
